import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/switchMap';
import type { MiddlewareAPI } from 'redux';
import { Observable } from 'rxjs/Observable';
import type { Location, RouterActionPush } from '@atlassian/jira-router';
import { removeIssueParentFromUrlByFilters } from '../../services/routing/issue-parent-url-change';
import { removeSelectedIssueFromUrl } from '../../services/routing/selected-issue-url-change';
import { CLOSE_DETAIL_VIEW } from '../../state/actions/detail-view';
import { getAppliedParentFilters } from '../../state/selectors/filters';
import type { ActionsObservable, State } from '../../state/types';

export const detailViewCloseEpic =
	(getLocation: () => Location, push: RouterActionPush) =>
	(action$: ActionsObservable, store: MiddlewareAPI<State>) =>
		action$.ofType(CLOSE_DETAIL_VIEW).switchMap((action) => {
			const state: State = store.getState();
			const filters: string[] | undefined = getAppliedParentFilters(state);
			const issueId: number | undefined = action.payload?.issueId;
			push(
				removeSelectedIssueFromUrl(
					removeIssueParentFromUrlByFilters(getLocation(), issueId, filters),
				),
			);
			return Observable.empty<never>();
		});
